<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">预警值设置</div>
    </div>
    <div class="modul-search">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="桥梁名称">
          <el-select
            v-model="bridgeName"
            @change="bridgeChange"
            @clear="getSetUpEarlyWarning"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in bridgeData"
              :key="index"
              :label="item.bridgeName"
              :value="item.bridgeUuid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-select
            v-model="equipmentType"
            @change="equipmentTypeChange"
            @clear="getSetUpEarlyWarning"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in equipmentTypes"
              :key="index"
              :label="item.equipmentTypeName"
              :value="item.equipmentTypeUuid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          ><el-button
            type="primary"
            :loading="btnLoading"
            @click="
              btnLoading = true
              getSetUpEarlyWarning()
            "
            >查询</el-button
          >
          <el-button
            type="primary"
            @click="addDataType"
            >新增</el-button
          ></el-form-item
        >
      </el-form>
    </div>
    <div class="modul-content">
      <div class="table-box">
        <el-table
          v-loading="loading"
          :data="tableData"
          :header-cell-style="{'text-align': 'left'}"
          :cell-style="{'text-align': 'left'}"
          max-height="500"
          border
          style="width: 100%"
        >
          <el-table-column
            label="编号"
            type="index"
            width="80px"
          ></el-table-column>
          <el-table-column
            label="桥梁名称"
            prop="bridgeName"
            width="100px"
          ></el-table-column>
          <el-table-column
            label="设备类型"
            prop="equipmentTypeName"
            width="100px"
          ></el-table-column>
          <el-table-column
            label="设备别名"
            prop="equipmentAnotherName"
          ></el-table-column>
          <el-table-column
            label="数据类型"
            prop="dataTypeName"
            width="100px"
          ></el-table-column>
          <el-table-column
            label="基准值"
            prop="standardValue"
            width="100px"
          ></el-table-column>
          <el-table-column
            label="通知间隔（小时"
            prop="timeGap"
            width="80px"
          ></el-table-column>
          <el-table-column label="预警值" prop="dataValue">
            <template #default="scope">
              <div class="warning-value">
                <div id="">{{ scope.row.beginWarningValue }}</div>
                <div class="input-line"></div>
                <div id="">{{ scope.row.endWarningValue }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="是否短信通知" width="80px" fixed="right">
            <template #default="scope">
              <el-switch
                v-model="scope.row.needSms"
                disabled
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80px" fixed="right">
            <template #default="scope">
              <el-button type="text" @click="bianJi(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="text-align: center; margin: 20px 0 0">
      <!--描述：分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :visible.sync="addVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      @close="cancelDialog()"
      width="65%"
    >
      <!-- <div class="dialog-height"> -->
      <span slot="title">
        <div class="modul-top1">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">预警值修改</div>
        </div>
      </span>
      <el-form
        :inline="true"
        label-width="100px"
        :model="upForm"
        ref="ruleForm"
        style="text-align: left"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="设备名称"
              ><el-input
                v-model="upForm.equipmentName"
                disabled
                class="dia-input"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="预警值">
              <div class="warning-value">
                <el-input
                  v-model="upForm.beginWarningValue"
                  type="number"
                  class="dia-input"
                ></el-input>
                <div class="input-line"></div>
                <el-input
                  v-model="upForm.endWarningValue"
                  type="number"
                  class="dia-input"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="基准值">
              <div class="warning-value">
                <el-input
                  v-model="upForm.standardValue"
                  type="number"
                  class="dia-input"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="数据类型">
              <div class="warning-value">
                <el-select
                  v-model="upForm.dataType"
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in dataTypes"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="通知间隔（小时）">
              <div class="warning-value">
                <el-input
                  v-model="upForm.timeGap"
                  type="number"
                  class="dia-input"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="是否短信通知">
              <div class="warning-value">
                <el-switch
                  v-model="upForm.needSms"
                  :active-value="1"
                  :inactive-value="0"
                ></el-switch>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- </div> -->
      <span
        slot="footer"
        class="dialog-footer"
        style="right: 20px; bottom: 20px; position: absolute"
      >
        <el-button type="primary" @click="add_sure()">确 定</el-button>
        <el-button @click="cancelDialog()">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="addDateTypeVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="65%"
    >
      <!-- <div class="dialog-height"> -->
      <span slot="title">
        <div class="modul-top1">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">新增</div>
        </div>
      </span>
      <el-form
        :inline="true"
        label-width="100px"
        :model="addForm"
        ref="dataTypeForm"
        style="text-align: left"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="桥梁名称"
              ><el-select
                v-model="addForm.bridgeName"
                @change="addbridgeChange"
                filterable
                placeholder="请选择桥梁"
              >
                <el-option
                  v-for="(item, index) in bridgeTree"
                  :key="index"
                  :label="item.bridgeName"
                  :value="item.bridgeName"
                ></el-option>
              </el-select></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="设备名称"
              ><el-select
                v-model="addForm.equipmentName"
                @change="equipmentNameChange"
                @visible-change="equipmentChange"
                filterable
                placeholder="请选择设备名称"
              >
                <el-option
                  v-for="(item, index) in equipmentArr"
                  :key="index"
                  :label="item.equipmentName"
                  :value="item.equipmentName"
                ></el-option>
              </el-select></el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="预警值">
              <div class="warning-value">
                <el-input
                  v-model="addForm.beginWarningValue"
                  type="number"
                  class="dia-input"
                ></el-input>
                <div class="input-line"></div>
                <el-input
                  v-model="addForm.endWarningValue"
                  type="number"
                  class="dia-input"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="基准值">
              <div class="warning-value">
                <el-input
                  v-model="addForm.standardValue"
                  type="number"
                  class="dia-input"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="数据类型">
              <div class="warning-value">
                <el-select
                  v-model="addForm.dataType"
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in dataTypes"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="通知间隔（小时）">
              <div class="warning-value">
                <el-input
                  v-model="addForm.timeGap"
                  type="number"
                  class="dia-input"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="是否短信通知">
              <div class="warning-value">
                <el-switch
                  v-model="addForm.needSms"
                  :active-value="1"
                  :inactive-value="0"
                ></el-switch>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- </div> -->
      <span
        slot="footer"
        class="dialog-footer"
        style="right: 20px; bottom: 20px; position: absolute"
      >
        <el-button type="primary" @click="addDateType">确 定</el-button>
        <el-button @click="addDateTypeVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'yujingzhi',
  data() {
    return {
      btnLoading: false,
      addVisible: false,
      bridgeData: [],
      bridgeName: '',
      equipmentType: '',
      equipmentTypes: [],
      time: [],
      formInline: {
        bridgeUuid: '',
        equipmentTypeUuid: '',
        pageSize: 10,
        pageNum: 1 //当前页数
      },
      total: 0,
      // 表格
      loading: false,
      tableData: [],
      // 修改预警值
      upForm: {
        equipmentName: '',
        beginWarningValue: '',
        endWarningValue: '',
        standardValue: '',
        dataType: '',
        timeGap: '',
        needSms: ''
      },
      dataTypeList: [
        {
          equipmentTypeUuid: '6fc26b612a61463dbf4208a0a041135c',
          equipmentTypeName: '表面应变计',
          dataType: [
            {label: '应变', value: 'YBJ_RATE_OFFSET'},
            {label: '应变频率', value: 'YBJ_RATE'},
            {label: '应变温度', value: 'TMP'}
          ]
        },
        {
          equipmentTypeUuid: '7472a8504ee5470799ebf21427ba73cc',
          equipmentTypeName: '环境温湿度',
          dataType: [
            {label: '温度', value: 'TMP'},
            {label: '湿度', value: 'HR'}
          ]
        },
        {
          equipmentTypeUuid: 'a278203311174465bc8ae95977334c21',
          equipmentTypeName: '静力水准仪',
          dataType: [
            {label: '位移', value: 'STATIC_LEVEL_OFFSET'},
            {label: '静力水准', value: 'STATIC_LEVEL'}
          ]
        },
        {
          equipmentTypeUuid: 'aad5b37a38fa4ede9c31c274c278bcf4',
          equipmentTypeName: 'GNSS',
          dataType: [
            {label: '位移X', value: 'GNSS_X_OFFSET'},
            {label: '位移Y', value: 'GNSS_Y_OFFSET'},
            {label: '位移Z', value: 'GNSS_Z_OFFSET'},
            {label: 'GNSS_X', value: 'GNSS_X'},
            {label: 'GNSS_Y', value: 'GNSS_Y'},
            {label: 'GNSS_Z', value: 'GNSS_Z'}
          ]
        },
        {
          equipmentTypeUuid: 'd67137e51312417284d1206d657736f3',
          equipmentTypeName: '索力加速度计',
          dataType: [{label: 'CABLE_FORCE', value: 'CABLE_FORCE'}]
        },
        {
          equipmentTypeUuid: 'eada02b7cdde49b582ab9afbb91d2b84',
          equipmentTypeName: '振动加速度计',
          dataType: [
            {label: '加速度峰值', value: 'PV'},
            {label: '加速度峰峰值', value: 'PPV'},
            {label: '加速度有效值', value: 'TRMS'}
          ]
        },
        {
          equipmentTypeUuid: 'd5f1014f044a47aa8f8b556060f4b90f',
          equipmentTypeName: '液位计',
          dataType: [
            {label: '液位', value: 'WATER_LEVEL'},
          ]
        }
      ],
      dataTypes:[],
      addDateTypeVisible:false,
      bridgeTree:[],
      equipmentArr:[],
      addForm:{
        bridgeName:"",
        equipmentName:"",
        beginWarningValue:0,
        endWarningValue:0,
        standardValue:0,
      },
    }
  },

  async mounted() {
    const res = await this.$api.sendPost('/biBridge/getBiBridgeTree', {"pageSize":99999,"pageNum":1,"bridgeName":"","bridgeUuid":""})
    if(res.errcode == 0){
      this.bridgeTree = res.data.list || []
    }
    // 获取-桥梁录入信息
    this.getBiBridgeBoPage()
    // 获取预警值列表
    this.getSetUpEarlyWarning()
  },
  watch: {
    path(one, two) {
      // this.formInline = {};
      console.log(one, two)
      // this.tableReq();
    }
  },
  computed: {
    path() {
      return this.$route.path
    },
    api() {
      return this.$config.host
    }
  },
  methods: {
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.formInline.pageSize = val
      this.getSetUpEarlyWarning(1)
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.formInline.pageNum = val
      this.getSetUpEarlyWarning()
    },
    // 桥梁名称选择
    async bridgeChange(e) {
      this.formInline.bridgeUuid = e
      this.equipmentType = ''
      const res = await this.$api.sendGet(
        '/biBridge/getBridgeEquipmentTypeScreenList',
        {
          bridgeUuid: e
        }
      )
      if (res.errcode === 0) {
        this.equipmentTypes = res.data
      } else {
        this.equipmentTypes = []
      }
    },
    addDataType(){
      this.addForm = {
        bridgeName:"",
        equipmentName:"",
        beginWarningValue:0,
        endWarningValue:0,
        standardValue:0,
      }
      this.addDateTypeVisible = true
    },
    async addbridgeChange(e){
      let arr = this.bridgeTree.find(k => k.bridgeName == e).equipmentList
      this.equipmentArr = [...new Map(arr.map(item => [item.equipmentName, item])).values()];
      this.addForm.equipmentName = ""
    },
    equipmentChange(e){
      if(e && !(this.addForm && this.addForm.bridgeName))return this.$message.warning("请先选择桥梁名称")
    },
    equipmentNameChange(e){
      let item = this.equipmentArr.find(k => k.equipmentName == e)
      this.dataTypes = this.dataTypeList.find(e => e.equipmentTypeName == item.equipmentTypeName).dataType || []
    },
    // 设备类型选择
    async equipmentTypeChange(e) {
      this.formInline.equipmentTypeUuid = e
    },
    // 获取-桥梁录入信息
    async getBiBridgeBoPage() {
      const res = await this.$api.sendPost('/biBridge/getBiBridgeBoPage', {
        pageSize: 9999,
        pageNum: 1
      })
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.bridgeData = res.data.list
        } else {
          this.bridgeData = []
        }
      }
    },
    // 获取预警值数据
    async getSetUpEarlyWarning(num) {
      this.loading = true
      num
        ? (this.formInline.pageNum = num)
        : (this.formInline.pageNum = this.formInline.pageNum)
      const res = await this.$api.sendPost(
        '/earlyWarning/getSetUpEarlyWarning',
        this.formInline
      )
      console.log('请求数据', res)
      this.btnLoading = false
      this.loading = false
      if (res.errcode === 0) {
        this.tableData = res.data.list
        this.total = res.data.total
      } else {
        this.tableData = []
      }
    },
    // 修改
    async bianJi(row) {
      console.log(row)
      let data = JSON.parse(JSON.stringify(row))
      this.upForm.equipmentName = data.equipmentName
      this.upForm.equipmentId = data.equipmentId
      this.upForm.beginWarningValue = data.beginWarningValue
      this.upForm.endWarningValue = data.endWarningValue
      this.upForm.needSms = data.needSms
      this.upForm.standardValue = data.standardValue
      this.upForm.timeGap = data.timeGap
      this.upForm.dataType = data.dataType
      this.upForm.equipmentWarningSetId = data.equipmentWarningSetId
      this.dataTypes = this.dataTypeList.find(e => e.equipmentTypeName == data.equipmentTypeName).dataType || []
      this.addVisible = true
      console.log(data)
      // const res = await this.$api.sendPost('/earlyWarning/updateSetUpEarlyWarning', this.upForm)
      // console.log(res)
    },
    // 确定
    async add_sure() {
      console.log(this.upForm)
      let data = {
        ...this.upForm,
        beginWarningValue: Number(this.upForm.beginWarningValue),
        endWarningValue: Number(this.upForm.endWarningValue),
        standardValue: Number(this.upForm.standardValue)
      }
      const res = await this.$api.sendPost(
        '/earlyWarning/updateSetUpEarlyWarning',
        data
      )
      if (res.errcode === 0) {
        this.$message.success(res.errmsg)
        this.addVisible = false
        this.loading = true
        this.btnLoading = false
        this.getSetUpEarlyWarning()
      } else {
        this.$message.error(res.errmsg)
      }
    },
    async addDateType(){
      if(!(this.addForm.bridgeName && this.addForm.equipmentName && this.addForm.dataType)){
        return this.$message.warning("请填写信息")
      }
      let data = {
        ...this.addForm,
        beginWarningValue: Number(this.addForm.beginWarningValue),
        endWarningValue: Number(this.addForm.endWarningValue),
        standardValue: Number(this.addForm.standardValue)
      }
     try{
       const res = await this.$api.sendPost(
        '/earlyWarning/updateSetUpEarlyWarning',
        data
      )
      if(res.errcode != 0) return this.$message.error(res.errmsg || "操作失败！")
      this.addDateTypeVisible = false
      this.getSetUpEarlyWarning()
     }catch(e){
        this.$message.error("操作失败，请检查是否已添加设备")
     }
    },
    // 取消
    cancelDialog() {
      // 关闭校验
      this.$refs.ruleForm.resetFields()
      this.addVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.modul-search {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.modul-content-title {
  // margin: 20px 0;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

::v-deep .el-dialog__body {
  height: 700px;
}

.warning-value {
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-line {
  margin: 0 10px;
  width: 50px;
  border-bottom: 1px solid #999999;
}
</style>
